import { GetStaticProps } from "next";

import { PLASMIC } from "@abnormal/plasmic-init";
import BlogLayout from "@layouts/BlogLayout";
import { PER_PAGE } from "@lib/blog";
import fetchForm from "@lib/fetchForm";
import { returnStaticProps } from "@lib/returnStaticProps";
import craft from "@pages/api/craft";
import {
  PlasmicComponent,
  PlasmicRootProvider,
  extractPlasmicQueryData
} from "@plasmicapp/loader-nextjs";
import QueryBlogIndex from "@queries/blog/QueryBlogIndex.graphql";

export const getStaticProps: GetStaticProps = async () => {
	// Hard code the page's uri
  const uri = "/blog";
  
  const plasmicData = await PLASMIC.maybeFetchComponentData([
    "BladesDynamicDemoBlade",
    "Footer"
  ], {
    // deferChunks: true,
  });
  if (!plasmicData) {
    throw new Error("No Plasmic design found");
  }

	// Fetch the page's data
	const response = await craft(QueryBlogIndex, { limit: PER_PAGE });

	const {
		pageEntry,
		posts,
		postCount,
		blogCategories,
		primaryNavigation,
		primaryCallToActions,
		persistentNav,
  } = response;
  
  // Cache the necessary Plasmic data fetched for the page
  const queryCache = await extractPlasmicQueryData(
    <PlasmicRootProvider loader={PLASMIC} prefetchedData={plasmicData}>
      <PlasmicComponent
        component="BladesDynamicDemoBlade"
      />
    </PlasmicRootProvider>
  );

	/*
		Fetch the form and pass form data as props
	*/
	let formData = null;

	// Use the form id specified by the selected form in the pageEntry (if there is one)
	const formId = pageEntry.form
		? pageEntry.form[0].formDetails[0].formId
		: null;

	if (formId) {
		formData = await fetchForm({ formId: formId });
	}

	// Return props if entry exists, otherwise check Retour for redirects or 404
	const returnResponse = await returnStaticProps(
		{
			navigation: {
				primaryNavigation,
				primaryCallToActions,
			},
			pageEntry,
			persistentNav,
			posts,
			blogCategories,
			formData,
			pageCount: Math.ceil(postCount / PER_PAGE),
      pageNumber: 1,
      plasmicData,
      queryCache
		},
		!pageEntry,
		uri
	);

	return returnResponse;
};

interface IProps {
	pageEntry: any;
	posts: any[];
  blogCategories: any[];
}

const Page = ({ pageEntry, posts, blogCategories }: IProps): JSX.Element => {
	return <></>;
};

Page.Layout = BlogLayout;

export default Page;
